export default "https://cdn-static.gokick.com/assets/4e1d6b599b0c658e33aa5c1b8604da35a9a49f05/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";